<template>
    <Head title="Lounge" />
    <div class="px-4 md:px-8">
        <LoungeDetails />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import LoungeDetails from '@/components/tools/lounges/lounge/index.vue';
import { Head } from '@inertiajs/vue3';
const loungeId = computed(() => usePage().props.id);
</script>
